import React, { useEffect, useState } from "react";
import { Progress } from "antd";

import EllipsisWithTooltip from "react-ellipsis-with-tooltip";
import Styles from "./style/listItem.module.scss";
import { functionService } from "../../../../../../../lib/functions";
import Loader from "../../../../../../../components/loader";
import ViewFeedback from "../../../../../../../components/viewFeedback/viewFeedback";
import StudentDetails from "../../../../modals/studentDetailsCard";
import StudentDetailsCardWithVideos from "../../../../modals/studentDetailsCardWithVideos";
import styled from "styled-components";
import { useParams } from "react-router-dom";
import CoffeeDropDown from "../../../../dropDown"
import { progressBarColor } from "../../../../../../../utils/commonFunctions";

const Heading = styled.p`
  color: #ff2c91;

  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 21px;
  margin-top: 10px;
`;

const SkillName = styled.p`
  color: #1e2228;

  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 21px;
`;

const SkillDetails = styled.span`
  color: #1e2228;

  font-style: normal;
  font-weight: 600;
  font-size: 12px;
  line-height: 21px;
`;

const CardContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px;
  background: #ffffff;
  border: 1px solid #efeff0;
  boxshadow: 0px 4px 44px rgba(29, 37, 45, 0.03);
  border-radius: ${(props) => (props.hideBorder === true ? "0px" : "12px")};
  margin-top: 20px;
  position: relative;
`;

const DetailsText = styled.p`
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  color: #939599;
  margin: 0;
  padding: 0 0 5px 0;
`;

const Center = ({ skillsList }) => (
  <div style={{ width:"65%" }} className={Styles.center}>
    <Heading>Skill Proficiency</Heading>
    <div className={Styles.centerPart}>
      {skillsList?.map(({ skills, top_percentile, percentile }) => {
        return (
          <div style={{ width: "70%" }}>
            <SkillName>
              <EllipsisWithTooltip placement="bottom">
                {skills}
              </EllipsisWithTooltip>
            </SkillName>
            <Progress
              strokeColor={progressBarColor(percentile)}
              percent={percentile}
              showInfo={false}
            />
            <SkillDetails>Top {top_percentile}%</SkillDetails>
          </div>
        );
      })}
    </div>
  </div>
);

const Right = ({
  getCandidateDetails,
  candidateID,
  loading,
  resume,
  setShortlistedCandidateList,
  whatsappConsent,
  getShortlistedCandiate, 
  status,
  setOpenRejectionFeedbackModal
}) => {

  const { recruiter_id, search_id } = useParams();
  const approveCandidate = async () => {
    let res = await functionService.post(
      `recruiter/approved-candidates/${recruiter_id}/${search_id}`,
      {
        candidates: [candidateID],
      }
    );
    if (res.status === true) {
      setShortlistedCandidateList((dataToShow) => {
        return dataToShow.filter((currentStudent) => {
          if (currentStudent.id !== candidateID) {
            return true;
          } else {
            return false;
          }
        });
      });
    }
  };
  const confirmRequest = async () => {
    await functionService.post("recruiter/change-status", {
     search_id: search_id,
     status: "CONFIRMED",
   });

 };

  const rejectCandidate = async () => {
    let res = await functionService.post(
      `recruiter/rejected-candidates/${recruiter_id}/${search_id}`,
      {
        candidates: [candidateID],
      }
    );
    
    if (res.status === true) {
      setShortlistedCandidateList((dataToShow) => {
        return dataToShow.map((currentStudent) => {
          if (currentStudent.id === candidateID) {
            return {...currentStudent,status:'REJECTED'}
          } else {
            return currentStudent;
          }
        });
      });
    }
  };

  const sendWhatsappRequest = async () => {
    let res = await functionService.post(
      `recruiter/whatsapp-message/${recruiter_id}/${search_id}`,
      {
        candidates: [candidateID],
      }
    );
    if (res.status === true) {
      getShortlistedCandiate()

      setShortlistedCandidateList((dataToShow) => {
        return dataToShow.map((currentStudent) => {
          if (currentStudent.id === candidateID) {
            return {...currentStudent,whatsapp_status:true}
          } else {
            return currentStudent;
          }
        });
      });
    }
  };

  const handleChange = ({key}) => {
    switch (key) {
      case 'Send Whatsapp':
        if(whatsappConsent===null){
          sendWhatsappRequest()
        }
        return;
      case 'Approve':
        approveCandidate();
        confirmRequest();
        return;
      case 'Reject':
        rejectCandidate();
        return;

      case 'Download Resume':
        window.open(resume);
        return;

      case 'View Rejection Feedback':
        setOpenRejectionFeedbackModal(true);
        return;

      default:
        return null;
    }
  };
  const actionOptions = status === 'REJECTED' ? ['Download Resume', 'View Rejection Feedback'] : 
    ["Send Whatsapp","Approve", "Reject", "Download Resume"];

  return <div style={{ width: "12%" }} className={Styles.right}>
    <StudentDetailsCardWithVideos
      studentId={candidateID}
      recruiter_id={recruiter_id}
      theme={1}
      style={{ marginBottom: '20px', width: '100%' }}
    />
    <CoffeeDropDown
      label="Actions"
      optionsList={actionOptions}
      changeHandler={handleChange}
    />

  </div>
};

const Left = ({
  profile_image,
  userImage,
  profileName,
  location,
  experience_month,
  experience_year,
  phone,
  email,
  downloadResume,
}) => (
  <div style={{ width: "25%" }} className={Styles.left}>
    <img
      src={profile_image}
      style={{ marginRight: "20px" }}
      className={`${Styles["image-inner"]} ${Styles.imageadjust}`}
    />
    <div>
      <div
        style={{
          display: "flex",
          justifyContent: "flex-start",
          alignItems: "baseline",
        }}
      >
        <h3 className={Styles.name}>{profileName} </h3>
        &nbsp;
        <img
          style={{ cursor: "pointer" }}
          src="/downloadResume.svg"
          onClick={() => {
            downloadResume();
          }}
        />
      </div>
      {experience_year || experience_month ? (
        <DetailsText>
          {location && (
            <>
              <img src="/location.svg" style={{ marginRight: "5px" }} />
              {location} | &nbsp;
            </>
          )}
          {experience_year ? `${experience_year} yrs` : ""} &nbsp;
          {experience_month ? `${experience_month} mos` : ""}&nbsp;
          {experience_year || experience_month ? "exp." : ""}&nbsp;
        </DetailsText>
      ) : (
        ""
      )}
      <DetailsText>{phone}</DetailsText>
      <DetailsText>{email}</DetailsText>
    </div>
  </div>
);

const ListViewCard = ({
  location,
  experience_month,
  experience_year,
  userImage,
  studentId,
  candidateID,
  resume,
  profileName,
  setSelectedListCandidate,
  selectedListCandidate,
  emailId,
  phone,
  skills,
  setShortlistedCandidateList,
  profile_image,
  whatsapp_status,
  whatsappConsent,
  getShortlistedCandiate, 
  status,
  designation,
  feedback
}) => {
  const [openShowDetailsModal, setOpenShowDetailsModal] = useState(false);
  const [studentDetails, setStudentDetails] = useState({});
  const [videosAvailable, setVideosAvailable] = useState(false);
  const [loading, setLoading] = useState(false);
  const [openRejectionFeedbackModal, setOpenRejectionFeedbackModal] = useState(false);

  const { recruiter_id } = useParams();
  const getCandidateDetails = async () => {
    setLoading(true);
    const { status, response } = await functionService.get(
      `recruiter/candidate-details/${recruiter_id}/${studentId}`
    );

    if (status) {
      setOpenShowDetailsModal(true);
      setStudentDetails(response?.data?.data[0]);
      setVideosAvailable(
        response?.data?.data[0]?.skillsdata?.filter(e=>e.screenrecording_url!=null).length > 0 ? true : false
      );
      setLoading(false);
    } else {
      setLoading(false);
    }
  };

  const WhatsAppMessage = styled.span`
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 0px;
    /* identical to box height, or 114% */

    text-align: center;

    padding: 10px;
    border-radius: 6px;
    background-color: ${props=>props.color?props.color:" #939599"};
    color: #ffffff;
  `;

  const WhatsAppContiner = styled.div`
    background: #fafafe;

    padding: 15px;
    border-radius: 0px 0px 8px 8px;

    border: 1px solid #efeff0;
    box-shadow: 0px 4px 44px rgba(29, 37, 45, 0.03);
  `;
  return (
    <div style={{ marginBottom: "10px", position: 'relative'}}>
      {status === 'REJECTED' ? 
        <img 
          src = '/candidate_rejected.svg' 
          style={{
            position: 'absolute', 
            top: '5px', 
            left: '-13px', 
            zIndex: '1'
          }}
          alt = 'Rejected'
        />
        :
        ''
      }
      <CardContainer hideBorder={whatsappConsent === "MSG_SENT"}>
        {status !== 'REJECTED' &&
          <input
            // disabled={whatsappConsent===null?false:true}
            checked={
              selectedListCandidate?.find((currentId) => currentId === studentId)
                ? true
                : false
            }
            type="checkbox"
            onChange={(e) => {
              if (e.target.checked) {
                setSelectedListCandidate((currentList) => {
                  return [...currentList, studentId];
                });
              } else {
                setSelectedListCandidate((currentList) => {
                  return currentList.filter(
                    (currentId) => currentId !== studentId
                  );
                });
              }
            }}
            style={{ position: "absolute", top: "10px", left: "20px" }}
          />
        }

        <Left
          profile_image={profile_image}
          downloadResume={() => {
            window.open(resume);
          }}
          experience_month={experience_month}
          experience_year={experience_year}
          location={location}
          userImage={userImage}
          profileName={profileName}
          phone={phone}
          email={emailId}
        />
        <Center skillsList={skills} />
        <Right
          candidateID={candidateID}
          setShortlistedCandidateList={setShortlistedCandidateList}
          getCandidateDetails={getCandidateDetails}
          loading={loading}
          resume={resume}
          whatsappConsent={whatsappConsent}
          getShortlistedCandiate={getShortlistedCandiate}
          status={status}
          setOpenRejectionFeedbackModal={setOpenRejectionFeedbackModal}
        />
      </CardContainer>
      {whatsappConsent === "waiting" && (
        <WhatsAppContiner>
          <WhatsAppMessage >Waiting for candidate's approval</WhatsAppMessage>
        </WhatsAppContiner>
      ) } {whatsappConsent === "interested" && (
        <WhatsAppContiner>
          <WhatsAppMessage color={'#21C17A'}>Interested</WhatsAppMessage>
        </WhatsAppContiner>
      )}
      {
        openRejectionFeedbackModal ? 
        <ViewFeedback 
          isModalOpen={openRejectionFeedbackModal}
          setIsModalOpen={setOpenRejectionFeedbackModal}
          image={profile_image}
          name={profileName}
          designation={designation}
          phone={phone}
          email={emailId}
          feedback={feedback}
          title={'Rejection Feedback'}
        />
        :
        ''
      }
    </div>
  );
};

export default ListViewCard;
